export const addGroupEmptyFormValues = {
  name: '',
  description: '',
};

export const DESCRIPTION_MAX_LENGTH = 140;
